import iCalParser from '../../moreCore/iCalParser/iCalParser';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './iCalViewer.html?raw';

import "../../moreCore/iCalParser/iCalParser";

import Edit from '../../moreCore/UI/Edit/Edit';
import "../../moreCore/UI/Edit/Edit";

import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import "../../moreCore/UI/StaticTable/StaticTable";

import moreCoreCalendar from '../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar';
import "../../moreCore/UI/moreCoreCalendar/moreCoreCalendar/moreCoreCalendar";

import TimeZoneSelector from '../../moreCore/UI/TimeZoneSelector/TimeZoneSelector';
import "../../moreCore/UI/TimeZoneSelector/TimeZoneSelector";
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import "../../moreCore/UI/CheckBox/CheckBox";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import FullscreenDialog from '../../moreCore/UI/FullscreenDialog/FullscreenDialog';
import "../../moreCore/UI/FullscreenDialog/FullscreenDialog";
import Calendar_Buttons from '../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons';
import "../../moreCore/UI/moreCoreCalendar/Calendar_Buttons/Calendar_Buttons";

class iCalViewer extends compose(iCalParser) {
	templateString: any = template;
     
    searchText_tableContainer: HTMLElement;
    searchText_calendarContainer: HTMLElement;
    resultViewContainer: HTMLElement;
    calendarContainer: HTMLElement;
    tableContainer: HTMLElement;
    timeZonSelectorContainer: HTMLElement;
    convertTimeZonesContainer: HTMLElement;
    searchButtonContainer_noCalendar: HTMLElement;
    searchButtonContainer: HTMLElement;
    messageContainer: HTMLElement;
    searchText_table: MdsLax<InstanceType<typeof Edit>>;
    searchText_calendar: MdsLax<InstanceType<typeof Edit>>;
    convertTimeZones_checkBox: MdsLax<InstanceType<typeof CheckBox>>;

    _isCalendarctive: boolean = false;
    _isTableActive: boolean = false;
    buttonClickTimeout: number = null;

    _isMobile: boolean = false;

    getICals_url: string = "ICalViewer/GetICals";
    getICalContent_url: string = "ICalViewer/GetICalContent";
    refreshIcal_url: string = "ICalViewer/RefreshIcal";

    _request: any;

    calendarItems: Array<moreCoreCalendarItem> = [];
    calendarItems_searchResult: Array<moreCoreCalendarItem> = [];

    table: MdsLax<InstanceType<typeof StaticTable>>;
    calendar: MdsLax<InstanceType<typeof moreCoreCalendar>>;
    calendarButtons: MdsLax<InstanceType<typeof Calendar_Buttons>>;
    timeZoneSelector: MdsLax<InstanceType<typeof TimeZoneSelector>>;

    dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    fullScreenDlg: MdsLax<InstanceType<typeof FullscreenDialog>> = null;

    _lastResponse_iCals: any;
    _lastResponse_icalContent: string;
    data_iCals: IResultFromICal;
    iCals_serachResult: Array<IEventParsedFromICal>;


    currentIcalEvents: IEventParsedFromICal[];
    currentIcalContent: any = null;

    tableLayout: StaticTable.Layout = {
        name: "default",
        label: "Standard",
        rows: [{
            colNamesInternal: ["description", "note", "lastSync", "showInCalendar", "download", "sync"],
            headings: ["Bezeichnung", "Anmerkung", "Letzte Änderung", "Im Kalender anzeigen", "Download", "Sync"], // hier default, wird ersetzt mit translationsim postCreate
            attributes: ["description", "note", "lastSync"],
            colspans: [1, 1, 1, 1, 1, 1],
            
        }
        ]
    };

    protected dateRangeStart: Date; // define max and min daterange pro wiget, damit die gleiche daten nicht 2 mal geladen werden
    protected dateRangeEnd: Date; // define max and min daterange pro wiget, damit die gleiche daten nicht 2 mal geladen werden
    calendar_columnViewHeadTextAttr: string = "columnview_head_text"; // default
    calendar_columnViewBodyTextAttr: string = "columnview_body_text";  // default

    calendarMinRange: Date;
    calendarMaxRange: Date;

    searchTextTable: string = null;
    searchTextCalendar: string = null;

    _isDirty_timeZone: boolean = false;
    currentIcalDescription: string = null;

    customBgColor: string = "#eb6b44";
    customTxtColor: string = "#000000";

    refreshButtonClass_refresh: string = "fas fa-sync";
    refreshButtonClass_spinner: string = "fas fa-sync fa-spin";
    refreshButtonClass_success: string = "fas fa-check";

    protected _allowedSyncInterval_inMinutes: number = 1; // default,  setSyncInterval(minutes: number): void

    current_tmp_enduser_url: string = null;

    tableFormatterfunction(cell: StaticTable.StaticTableCell<any>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            //"description", "note", "lastSync", "showInCalendar", "download", "sync"
            case "showInCalendar":
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": this.translations["Generic_show"],
                    "class": "mds-button-base round w3-large w3-center tertiaryBG mds-hover-dark",
                    "value": colName,
                    "onclick": lang.hitch(this, "tableRowButton_click_showInCalendar", { entity: entity })
                }, node);

                this.UiModder.domConstruct.create("SPAN", { "innerHTML": this.translations["Generic_show"], "class": "medium_screen large_screen" }, btn)
                this.UiModder.domConstruct.create("I", { "class": "fas fa-search-plus small_screen" }, btn)
                return true;
                break;

            case "download":
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    //"innerHTML": "Download",
                    "class": "mds-button-base round w3-large w3-center tertiaryBG mds-hover-dark",
                    "value": colName,
                    "onclick": lang.hitch(this, "tableRowButton_click_download", { entity: entity })
                }, node);

                this.UiModder.domConstruct.create("SPAN", { "innerHTML": "Download", "class": "medium_screen large_screen" }, btn);
                this.UiModder.domConstruct.create("I", { "class": "fas fa-download small_screen" }, btn);
                return true;
                break;

            case "sync":

                let syncInterval = (new Date().getTime() - new Date(entity["lastSync"]).getTime()) / 1000 / 60; //minutes

                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    "innerHTML": "",
                    "class": "mds-button-base round w3-large w3-center tertiaryBG mds-hover-dark",
                    "value": colName,
                    "onclick": lang.hitch(this, function (evt) {
                        console.log(evt.target);
                        let button: HTMLButtonElement;
                        if (evt.target.tagName == "BUTTON") {
                            button = evt.target;
                        } else if (evt.target.tagName == "I") {
                            button = evt.target.parentElement;
                        }
                        this.tableRowButton_click_calculateIcal({ entity: entity, button: button });
                    })
                }, node);

                let buttonIconClass: string;

                if (syncInterval < this._allowedSyncInterval_inMinutes) {
                    buttonIconClass = this.refreshButtonClass_success;
                    this.UiModder.domAttr.set(btn, "disabled", true);
                } else {
                    this.UiModder.domAttr.remove(btn, "disabled");
                    buttonIconClass = this.refreshButtonClass_refresh;
                }

                this.UiModder.domConstruct.create("i", { "class": buttonIconClass }, btn);
                return true;
                break;

            case "lastSync":
                if (value) {
                    var sYear: string = value.slice(0, 4);
                    var sMonth: string = value.slice(5, 7);
                    var sDay: string = value.slice(8, 10);
                    var sHour: string = value.slice(11, 13);
                    var sMinute: string = value.slice(14, 16);
                    node.innerHTML = `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
                } else {
                    node.innerHTML = null;
                }
                return true;
                break;

            default:
                return false;
        }
    }

    _onDownloadItemResult(response): void {
        console.log("_onDownloadItemResult: ", response);
    }

    /// METHODS -----------------------------------------------------------------------------------------------------------------------------------------------
    // EVENTS ------------------------------------------------------START

    _onValueChange_searchTextTable(evt): void {
        let value: string = this.searchText_table.getValue()
        if (value) {
            this.searchTextTable = value;
        } else {
            this.searchTextTable = null;
        }
    }
    _onValueChange_searchTextCalendar(evt): void {
        let value: string = this.searchText_calendar.getValue()
        if (value) {
            this.searchTextCalendar = value;
        } else {
            this.searchTextCalendar = null;
        }
    }

    _onclick_search(evt): void {

        if (this._isDirty_timeZone === true && this._lastResponse_icalContent) {
            this.parseICalContent(this._lastResponse_icalContent);
        }

        this._handleTextSearch();
    }

    _onValueChange_timeZoneSelector(): void {
        console.log("Zielgebiet UTC Offset in strunden: ", this.timeZoneSelector.getUtcOffset() / 1000 / 60 / 60);
        this.foreignUTCOffset_ms = this.timeZoneSelector.getUtcOffset();

        this._isDirty_timeZone = true;
    }

    _onValueChange_convertTimeZones_checkBox(evt): void {
        let value = this.convertTimeZones_checkBox.getValue();
        this.convertTimeZones = value;
        if (value === true) {
            this.UiModder.domClass.remove(this.timeZonSelectorContainer, "w3-hide");
            this.foreignUTCOffset_ms = this.timeZoneSelector.getUtcOffset();
        } else {
            this.UiModder.domClass.add(this.timeZonSelectorContainer, "w3-hide");
            this.foreignUTCOffset_ms = null;
        }
        this._isDirty_timeZone = true;
    } 

    tableRowButton_click_calculateIcal(rowData: { entity: string, button: HTMLButtonElement }): void {
        this.UiModder.domAttr.set(rowData.button, "innerHTML", null);
        this.UiModder.domConstruct.create("i", { "class": this.refreshButtonClass_spinner }, rowData.button);

        this.refreshIcal(rowData.entity["ID"]);
    }

    tableRowButton_click_showInCalendar(rowData: { entity: object }): void {

        if (rowData.entity["description"]) this.currentIcalDescription = rowData.entity["description"]; /// gibts nicht im Ical content -> hier merken für modal dialog
        this.current_tmp_enduser_url = rowData.entity["tmp_enduser_url"];
        this.loadICalContent(rowData.entity["ID"]);
    }

    tableRowButton_click_download(rowData: { entity: object }): void {
        if (rowData.entity["tmp_enduser_url"]) {
            window.open(rowData.entity["tmp_enduser_url"]);
        } else {
            alert("no url attribute");
        }
    }

    // EVENTS ------------------------------------------------------END
    // ICALS -----------------------------------------------------START

    sortData(entityList: Array<any>, propertyName: string, sortDirection: "DESC" | "ASC"): Array<any> {

        let compareFuction: any;
        let this_smogler: any = this;

        // wenn es einen Gruppierungsparam gibt
        if (propertyName) {
            let attrValue: string;

            //eine beliebige Value finden, um den Type zu kennen
            for (let i = 0; i < entityList.length; i++) {
                attrValue = this.PitHelper.getEntityAttributeValue(entityList[i], propertyName, more.PitHelperStructureFormatType.json);
                if (attrValue) { break; }

            }

            if (!isNaN(Number(attrValue))) {
                // wenn es eine Zahl ist
                if (sortDirection == "DESC") {

                    compareFuction = function (a, b) {
                        let result: any = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json) -
                            this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json);
                        return result;
                    }

                } else {

                    compareFuction = function (a, b) {
                        let result: any = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json) -
                            this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json);
                        return result;
                    }

                }

            } else {

                //wenn es ein String ist

                if (sortDirection == "DESC") {
                    compareFuction = function (a, b) {

                        let fa = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        let fb = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        if (fa < fb) {
                            return 1;
                        }
                        if (fa > fb) {
                            return -1;
                        }
                        return 0;
                    }
                } else {
                    compareFuction = function (a, b) {
                        //console.log(a, b)
                        let fa = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        let fb = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    }
                }
            }

            entityList.sort(compareFuction);

        }

        return entityList;
    }

    refreshIcal(icalId: string): void {

        let data: { ID: string } = { ID: icalId };

        this.RequestManager.post(
            window.appRoot + this.refreshIcal_url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onRefreshIcalResult"),
            lang.hitch(this, function (err) {
                alert("ERROR: " + err["Message"])
                console.log(err);
            }),
            false // sync
        );
    }

    _onRefreshIcalResult(response): void {

        if (this.data_iCals["icals"]) {
            console.log(response);
            if (response && response.status == "Updated successfully" && response.ID) {

                //let icalContent: string = response.content;
                //delete response.content; // warum?

                for (let i = 0; i < this.data_iCals["icals"].length; i++) {
                    if (this.data_iCals["icals"][i].ID == response.ID) {
                        this.data_iCals["icals"][i] = response;
                    }
                }
                this._handleTextSearch();
            }
        }

        if (this.currentIcalContent != null ) {
            this.parseICalContent(response.content);
        }
    }

    parseICalContent(content: string): void {

        this.currentIcalContent = this.parseFromICal(content);

        console.log("parseICalContent: ", this.currentIcalContent)

        if (this.currentIcalContent) {

            if (this.currentIcalContent.events.length == 0) {
                this._showErrorMessage(this.messageContainer, this.translations["iCalViewer__NoICalEventsToShow"], true);
            } else {
                this._showErrorMessage(this.messageContainer, this.translations["iCalViewer__NoICalEventsToShow"], false);
            }
            
            this.currentIcalEvents = this.sortData(this.currentIcalContent.events, "dtstart.value", "ASC");

            this.createCalendarItems(this.currentIcalEvents);
        } else {
            this._showErrorMessage(this.tableContainer, this.translations["Generic__no_results_for_search"], true);
        }
    }

    loadICals(searchText: string = ""): void {
        if (this._request != null) {
            this._request.cancel();
        }

        let data: object = {
            searchText: searchText
        };


        this._request = this.RequestManager.post(
            window.appRoot + this.getICals_url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onLoadICalsResult"),
            lang.hitch(this, "_onLoadICalsError"),
            false // sync
        );
    }

    _onLoadICalsResult(response): void {

        this._lastResponse_iCals = this.data_iCals;
        this.data_iCals = response;
        console.log("DATA_ICALS: ", this.data_iCals);
        if (this.data_iCals["icals"] && this.data_iCals["icals"].length) {
            this._handleTextSearch();
        } else {
            this._showErrorMessage(this.tableContainer, this.translations["iCalViewer__no_icas"], true);
        }
    }

    _onLoadICalsError(err): void {
        console.log("_onLoadICalsError", err);
    }

    loadICalContent(iCalID: string): void {
        if (this._request != null) {
            this._request.cancel();
        }

        let data: object = {
            ID: iCalID
        };

        console.log("loadICalContent params: ", data)

        this._request = this.RequestManager.post(
            window.appRoot + this.getICalContent_url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onLoadICalContentResult"),
            lang.hitch(this, "_onLoadICalContentError"),
            false // sync
        );
    }

    _onLoadICalContentResult(response: any): void {
        console.log("RESPONSE: ", response);
        if (response.content) {
            this._lastResponse_icalContent = response.content;
            this.parseICalContent(response.content);
        }
    }
    _onLoadICalContentError(err: any): void {
        console.log("_onLoadICalContentError: ", err);
    }


    // ICALS -----------------------------------------------------END
    // ------------------TABLE ----------------------------START

    _setTable(entityList?: any): void {
        
        console.log("_setTable: ", entityList);

        if (this.table != null) this.table.destroy();

        this._showErrorMessage(this.tableContainer, null, false);

        this.table = new StaticTable();

        this.table["refreshButtonClass_refresh"] = this.refreshButtonClass_refresh;
        this.table["refreshButtonClass_spinner"] = this.refreshButtonClass_spinner;
        this.table["refreshButtonClass_success"] = this.refreshButtonClass_success;
        this.table["_allowedSyncInterval_inMinutes"] = this._allowedSyncInterval_inMinutes;

        if (this.tableFormatterfunction != null) this.table.setFormatter(this.tableFormatterfunction);

        if (this.tableLayout != null) {
            this.table.setLayout(this.tableLayout);

            this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        } else {
            alert("tableLayout .. ??");
        }

        if (entityList) {

            this.table.setData(entityList);

            this.tableContainer.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });

        }

        this.table.setCyAttribute("iCalViewerTable");

        if (this.tableContainer) this.UiModder.domClass.remove(this.tableContainer, "w3-hide");

        this._isTableActive = true;
    }
    // ----------------------------------TABLE ----------------------------END
   
    //// CALENDAR handling ---------------------------------------------------START

    calendar_itemClick_downloadEvent(item: moreCoreCalendarItem) {
        let data = { ID: item.id }
        this.RequestManager.post(
            window.appRoot + "ICalViewer/DownloadEvent",
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onDownloadItemResult"),
            lang.hitch(this, function (err) {
                alert("ERROR: " + err["Message"])
                console.log(err);
            }),
            false // sync
        );
    }

    createCalendarItems(events: Array<{}>): void {

        this.calendarItems = [];

        for (let event of events) {

            let item: moreCoreCalendarItem = {
                id: event["uid"],
                startTime: event["dtstart"]["value"],
                endTime: event["dtend"]["value"],
                allDay: this.isAllDay,
                editable: false,
                Classname: "",
                moveEnabled: false,
                resizeEnabled: false,
            }
            item["columnview_head_text"] = event["location"];
            item["columnview_body_text"] = event["summary"];
            item["categories"] = event["categories"];
            item["description"] = event["description"];
            item["tmp_enduser_url"] = this.current_tmp_enduser_url;

            if (this.customBgColor) item["Default_BackColor"] = this.customBgColor;
            if (this.customTxtColor) item["Default_TextColor"] = this.customTxtColor;

            this.calendarItems.push(item);
        }

        console.log("CALENDARITEMS ", this.calendarItems);

        if (this.searchTextCalendar) {
            this.calendarItems_searchResult = [];
            for (let item of this.calendarItems) {
                if (item.columnview_body_text.toLowerCase().indexOf(this.searchTextCalendar.toLowerCase()) != -1 || item.columnview_head_text.toLowerCase().indexOf(this.searchTextCalendar.toLowerCase()) != -1) {
                    this.calendarItems_searchResult.push(item);
                }
            }

            if (this.calendarItems_searchResult.length > 0) {
                if (this._isCalendarctive) this._setCalendar(this.calendarItems_searchResult, 600, true, "month", this.calendarItems_searchResult[0].startTime);
            } else {
                if (this.calendar) this.calendar.destroy();
                this.calendar = null;
                this._showErrorMessage(this.calendarContainer, this.translations["Generic__no_results_for_search"], true)
            }

        } else {
            if (this.calendarItems.length) this._setCalendar(this.calendarItems, 600, true, "month", this.calendarItems[0].startTime);
        }
    }

    protected _setCalendar(
        entityList?: Array<moreCoreCalendarItem>,
        domNodeHeight?: number,
        showButtons?: boolean,
        calendarMode?: string,
        displayDate?: string,  /* YYYY-MM-dd*/
    ): void {

        let calendarData: moreCoreCalendarData = null;

        //ranges für calndar bestimmen, damit man nicht durch das Nichts blättert
        this.calendarMinRange = new Date(entityList[0].startTime);
        let noRefEntityList = [...this.calendarItems];
        let sortedForEndTime = this.sortData(noRefEntityList, "endTime", "DESC");
        this.calendarMaxRange = new Date(sortedForEndTime[0].endTime);

        if (this.calendar == null) {
            // wenn noch kein Kalender da ist, kreieren wir einen
            if (this.calendarContainer) {

                this._showErrorMessage(this.calendarContainer, null, false);

                this.calendar = new moreCoreCalendar();
                this.calendar.setItemClickFunction(this.calendarItemClickFunction);
                this.UiModder.domStyle.set(this.calendar.domNode, "position", "relative")


                if (this._isMobile === true) {

                    this.fullScreenDlg = new FullscreenDialog({ destroyOnClose: false });
                    this.fullScreenDlg.addNodeToContent(this.calendar.domNode);
                    if (this.currentIcalDescription) {
                        let headerText: HTMLElement = this.UiModder.domConstruct.create("h2", { "innerHTML": this.currentIcalDescription });
                        this.fullScreenDlg.addNodeToHeader(headerText);
                        this.UiModder.domStyle.set(this.fullScreenDlg.headerContentnode, "border-bottom", "1px solid rgba(150,150,150,0.3)");
                    }

                    this.fullScreenDlg.show();
                } else {
                    this.calendar.placeAt(this.calendarContainer);
                }

                this.UiModder.domStyle.set(this.calendar.domNode, "height", domNodeHeight + "px");

                if (showButtons) {
                    this.calendarButtons = new Calendar_Buttons()
                    this.configureButtons(this.calendar);
                    this.calendarButtons.placeAt(this.calendarContainer, "first")

                    //this.calendar.showCalendarButtons(true); // buttons zeigen
                    //this.calendar.showButton("todayButton", false);
                } else {
                    //this.calendar.showCalendarButtons(false);
                }

                //calenar configurieren
                this.calendar.configureCalendar(); // default config - setzt das displayDate zu heute

                if (this.calendar_columnViewHeadTextAttr) this.calendar.setColumnView_headText_attribute(this.calendar_columnViewHeadTextAttr);
                if (this.calendar_columnViewBodyTextAttr) this.calendar.setColumnView_bodyText_attribute(this.calendar_columnViewBodyTextAttr);

                if (displayDate) {
                    this.calendar.setDate(displayDate);
                }
            } else {

                alert("no calendar ContainerNode specified");
                return null;
            }

        } else if (this._isMobile === true) {
            this.fullScreenDlg.show();
        }
        this.calendar.setMinDateAllowed(this.calendarMinRange);
        this.calendar.setMaxDateAllowed(this.calendarMaxRange);


        if (this.calendar && entityList) { // interface calendarData { items: Array<moreCoreCalendarItem>, mode: string, displayDate: string }

            calendarData = { items: entityList, mode: calendarMode, displayDate: displayDate };

            this.calendar.setData(calendarData);
        }


        this._isCalendarctive = true;
        this._isDirty_timeZone = false;

        this.setInputsLayout_for_calendar();

        if (this._isMobile === false) {
            this.UiModder.domClass.remove(this.calendarContainer, "w3-hide");
            this.calendarContainer.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
        
    }

    configureButtons(calendar: MdsLax<InstanceType<typeof moreCoreCalendar>>) {

              // ist so eh nicht mehr einsatzfähig. die Buttons haben ihre Nodes inzwischen schon auf private gesetzt.


    }

    setInputsLayout_for_calendar(): void {

        this.UiModder.domClass.remove(this.searchText_tableContainer, "m7");
        this.UiModder.domClass.add(this.searchText_tableContainer, "m3");
        this.UiModder.domClass.remove(this.searchText_calendarContainer, "w3-hide");
        this.UiModder.domClass.remove(this.convertTimeZonesContainer, "w3-hide");
        this.UiModder.domClass.remove(this.searchButtonContainer, "w3-hide");
        this.UiModder.domClass.add(this.searchButtonContainer_noCalendar, "w3-hide");

    }

    calendarItemClickFunction = lang.hitch( this, function (item: moreCoreCalendarItem): void {
        console.log("ITEMCLICK: ", item);

        if ((this as any).dlg != null) {
            if ((this as any).dlg.modalDlgNode) (this as any).dlg.close();
            (this as any).dlg = null;
        }

        (this as any).dlg = new GenericDialog();

        let userAgentAboText: string = "<br><br><hr>" + window.translations["iCalViewer__LinkAboText"] +"<br>" + item["tmp_enduser_url"];
        let textDiv = document.createElement("DIV");
        textDiv.innerHTML = userAgentAboText;

        (this as any).dlg.set("header", item[(this as any).columnView_headText_attribute]);
        (this as any).dlg.set("content", item[(this as any).columnView_bodyText_attribute]);
        (this as any).dlg.set("closeBtn", true);

        (this as any).dlg.addNodeToContent(textDiv, "last");

        (this as any).dlg.setUserdefinedButton("Download Event", "fas fa-download", lang.hitch(this, function (item) {
            (this as any).calendar_itemClick_downloadEvent(item);
        }, item), false);

        (this as any).dlg.show();
    })

    //// CALENDAR handling -----------------------------------------------------END

    _showErrorMessage(container: HTMLElement, message: string, bShow: boolean): void {

        if (bShow == true) {
            container.innerHTML = null;
            this.UiModder.domClass.add(container, ["w3-pale-red", "w3-text-red", "w3-large", "w3-center"]);
            this.UiModder.domAttr.set(container, "innerHTML", message);
            this.UiModder.domConstruct.create("i", { "class": "fa fa-exclamation-triangle", "innerHTML": "&nbsp;" }, container, "first");
        } else {
            this.UiModder.domClass.remove(container, ["w3-pale-red", "w3-text-red", "w3-large", "w3-center"]);
            this.UiModder.domAttr.set(container, "innerHTML", null);
        }

    }

    _handleTextSearch() {
        if (this.searchTextTable) {
            this.iCals_serachResult = [];
            for (let ical of this.data_iCals["icals"]) {
                if ((ical.description.toLowerCase().indexOf(this.searchTextTable.toLowerCase())) != -1 || (ical.note.toLowerCase().indexOf(this.searchTextTable.toLowerCase())) != -1) {
                    this.iCals_serachResult.push(ical);
                }
            }

            if (this.iCals_serachResult.length > 0) {
                this._setTable(this.iCals_serachResult);
            } else {
                if (this.table) this.table.destroy();
                this.table = null;
                this._showErrorMessage(this.tableContainer, this.translations["Generic__no_results_for_search"], true)
            }
        } else {
            this._setTable(this.data_iCals["icals"]);
        }

        if (this.searchTextCalendar) {
            this.calendarItems_searchResult = [];
            for (let item of this.calendarItems) {
                if (item.columnview_body_text.toLowerCase().indexOf(this.searchTextCalendar.toLowerCase()) != -1 || item.columnview_head_text.toLowerCase().indexOf(this.searchTextCalendar.toLowerCase()) != -1) {
                    this.calendarItems_searchResult.push(item);
                }
            }

            if (this.calendarItems_searchResult.length > 0) {
                if (this._isCalendarctive) this._setCalendar(this.calendarItems_searchResult, 600, true, "month", this.calendarItems_searchResult[0].startTime);
            } else {
                if (this.calendar) this.calendar.destroy();
                this.calendar = null;
                this._showErrorMessage(this.calendarContainer, this.translations["Generic__no_results_for_search"], true)
            }
        } else {
            if (this._isCalendarctive && this.calendarItems.length > 0) {
                this._setCalendar(this.calendarItems, 600, true, "month", this.calendar._timeInterval[0]);
            }
        }
    }

    // Getter&setters ------------------------------------------------------------------------

    setCustomBgColor(color: string): void {
        this.customBgColor = color;
    }

    setCustomTxtColor(color: string): void {
        this.customTxtColor = color;
    }

    setSyncInterval(minutes: number): void {
        this._allowedSyncInterval_inMinutes = minutes;
        this.table["_allowedSyncInterval_inMinutes"] = minutes;
    }
    _setSyncIntervalAttr(minutes: number): void {
        this.setSyncInterval(minutes);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // touchscreen
        if ("ontouchstart" in document.documentElement) {
            this._isMobile = true;
        }

        // translations für tableheaders setzten (headers: ["Bezeichnung", "Anmerkung", "Letzte Änderung", "Im Kalender anzeigen", "Download", "Sync"])
        this.tableLayout.rows[0].headings = [
            this.translations["iCalViewer__tableHeader_description"],
            this.translations["iCalViewer__tableHeader_note"],
            this.translations["iCalViewer__tableHeader_lastSync"],
            this.translations["iCalViewer__tableHeader_show_in_calendar"],
            "Download",
            "Sync"]; // totale Katastrophe, was soll denn der Blödsinn...

        this.timeZoneSelector.setInputDate(new Date()); 
        this.loadICals();

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //console.log("HISTORY STARTUP: ", history.state);
    }
}

export default mdsWidget(iCalViewer);